import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';
import {AddonRendererComponent} from './add-ons/add-on-renderer/addon-renderer.component';
import {NoAddonsComponent} from './add-ons/no-addons/no-addons.component';
import {resolveAddon} from './add-ons/resolvers/add-on.resolver';
import {EntryComponent} from './common/components/entry/entry.component';
import {LayoutComponent} from './common/components/layout/layout.component';
import {RedirectCheckoutLoaderComponent} from './common/components/redirect-checkout-loader/redirect-checkout-loader.component';
import {resolveCartItems} from './common/shopping-cart/cart-item.resolver';
import {ShippingFormComponent} from './tax-and-shipping/components/shipping-form/shipping-form.component';
import {SuggestedAddressComponent} from './tax-and-shipping/components/suggested-address/suggested-address.component';
import {AddressGuard} from './tax-and-shipping/guards/address-guard.guard';
import {FailedAddOnsComponent} from './add-ons/failed-add-ons/failed-add-ons.component';
import {CheckoutComponent} from './common/shopping-cart/components/checkout/checkout.component';
import {HiddenComponent} from './common/components/hidden/hidden.component';

const routes: Routes = [
  {
    path: 'entry',
    component: EntryComponent,
    outlet: 'commerceElement',
    resolve: {
      cartItems: resolveCartItems,
    },
  },
  {
    path: 'commerce',
    component: LayoutComponent,
    outlet: 'commerceElement',
    children: [
      {
        path: 'failed-add-ons',
        component: FailedAddOnsComponent,
      },
      {
        path: 'catalog/:catalogId',
        component: AddonRendererComponent,
        runGuardsAndResolvers: 'paramsChange',
        resolve: {
          addon: resolveAddon,
        },
      },
      {
        path: 'address',
        component: ShippingFormComponent,
        canActivate: [AddressGuard],
      },
      {
        path: 'suggested-address',
        component: SuggestedAddressComponent,
      },
    ],
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
    outlet: 'commerceElement',
  },
  {
    path: 'hidden',
    component: HiddenComponent,
    outlet: 'commerceElement',
    resolve: {
      cartItems: resolveCartItems,
    },
  },
  {
    path: 'no-add-ons',
    component: NoAddonsComponent,
    outlet: 'commerceElement',
  },
  {
    path: 'error',
    component: NoAddonsComponent,
    outlet: 'commerceElement',
  },
  {
    path: 'redirect-to-checkout',
    component: RedirectCheckoutLoaderComponent,
    outlet: 'commerceElement',
  },
  {
    path: '',
    redirectTo: 'entry',
    pathMatch: 'full',
    outlet: 'commerceElement',
  },
  {
    path: '**',
    component: NoAddonsComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      useHash: true,
    }),
    BrowserModule,
  ],
  declarations: [],
  exports: [RouterModule],
})
export class CommerceRoutingModule {}
